import eventHelpers from 'utils/eventHelpers';
import DOMHelper from 'utils/DOMHelpers';
import scrollTo from 'utils/scrollTo';

/**
 * @module ScrollTop
 */
class ScrollTop {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._onClick = this._onClick.bind(this);
        this._onScrollRaf = eventHelpers.raf(this._onScroll.bind(this));

        this.load();
    }

    /**
     * Base options
     */
    static get options() {
        return {
            activeClassName: 'scrolltop--active',
            activateFrom: 400,
            target: window
        };
    }


    /**
     * Construct module
     */
    load() {
        this._element.addEventListener('click', this._onClick);
        window.addEventListener('scroll', this._onScrollRaf, { passive: true });

        this._toggleActiveState();
    }


    /**
     * On element click event
     * @param {object} e - event object
     */
    _onClick(e) {
        e.preventDefault();
        scrollTo(window, 0);
        this._updateHistory(e.target.href);
    }


    /**
     * On scroll event handler
     * @private
     */
    _onScroll() {
        this._toggleActiveState();
    }


    /**
     * Update the browser history
     * @param {string} url - The new url
     */
    _updateHistory(url) {
        if (history.replaceState) {
            history.replaceState(null, null, url);
        }
    }


    /**
     * Toggle the active state of the element based on the vertical scroll position of the page
     */
    _toggleActiveState() {
        const classname = this._options.activeClassName;
        const hasClassname = this._element.classList.contains(classname);

        if (DOMHelper.getScrollPosition(window) >= this._options.activateFrom) {
            if (!hasClassname) {
                this._element.classList.add(classname);
            }
        } else if (hasClassname) {
            this._element.classList.remove(classname);
        }
    }
}

// Exports
export default ScrollTop;
